import { Ban, Folder, Loader2 } from "lucide-react";
import { Button } from "../../../button/button";

type Props = {
  isLoading: boolean;
  error?: string;
  folders?: string[];
  onFolderClick: (folderName: string) => void;
};

export const ExplorerDirectoryList = ({ isLoading, error, folders, onFolderClick }: Props) => {
  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-gray-400">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-[12px]">Loading folders...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-red-400">
        <Ban className="h-6 w-6" />
        <span className="text-[12px] whitespace-pre-line">{error}</span>
      </div>
    );
  }

  return (
    <ul className="flex-1 space-y-1 overflow-y-auto p-2">
      {folders?.length === 0 && (
        <li className="p-8 text-center text-[12px] text-gray-400 italic">
          No subfolders found in this directory.
        </li>
      )}
      {folders?.map((folder) => (
        <li key={folder}>
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            justify="start"
            title={folder}
            onClick={() => onFolderClick(folder)}
            className="group h-auto gap-3 rounded-md py-2 font-normal text-gray-700 hover:bg-blue-50 hover:text-blue-700"
          >
            <Folder className="h-4 w-4 shrink-0 fill-blue-50 text-blue-500 group-hover:fill-blue-200" />
            <span className="truncate text-left">{folder}</span>
          </Button>
        </li>
      ))}
    </ul>
  );
};
